/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScoreSubmissionMatchResult } from './ScoreSubmissionMatchResult';
import {
    ScoreSubmissionMatchResultFromJSON,
    ScoreSubmissionMatchResultFromJSONTyped,
    ScoreSubmissionMatchResultToJSON,
    ScoreSubmissionMatchResultToJSONTyped,
} from './ScoreSubmissionMatchResult';

/**
 * 
 * @export
 * @interface ScoreSubmissionResultResponse
 */
export interface ScoreSubmissionResultResponse {
    /**
     * 
     * @type {ScoreSubmissionMatchResult}
     * @memberof ScoreSubmissionResultResponse
     */
    matchResult: ScoreSubmissionMatchResult;
    /**
     * 
     * @type {string}
     * @memberof ScoreSubmissionResultResponse
     */
    status: string;
    /**
     * 
     * @type {boolean}
     * @memberof ScoreSubmissionResultResponse
     */
    awaitingConfirmation: boolean;
    /**
     * Best-of-X series state. Shape determined by BestOfSeriesService.SeriesState.
     * @type {{ [key: string]: any; }}
     * @memberof ScoreSubmissionResultResponse
     */
    seriesState?: { [key: string]: any; };
}

/**
 * Check if a given object implements the ScoreSubmissionResultResponse interface.
 */
export function instanceOfScoreSubmissionResultResponse(value: object): value is ScoreSubmissionResultResponse {
    if (!('matchResult' in value) || value['matchResult'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('awaitingConfirmation' in value) || value['awaitingConfirmation'] === undefined) return false;
    return true;
}

export function ScoreSubmissionResultResponseFromJSON(json: any): ScoreSubmissionResultResponse {
    return ScoreSubmissionResultResponseFromJSONTyped(json, false);
}

export function ScoreSubmissionResultResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScoreSubmissionResultResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'matchResult': ScoreSubmissionMatchResultFromJSON(json['matchResult']),
        'status': json['status'],
        'awaitingConfirmation': json['awaitingConfirmation'],
        'seriesState': json['seriesState'] == null ? undefined : json['seriesState'],
    };
}

export function ScoreSubmissionResultResponseToJSON(json: any): ScoreSubmissionResultResponse {
    return ScoreSubmissionResultResponseToJSONTyped(json, false);
}

export function ScoreSubmissionResultResponseToJSONTyped(value?: ScoreSubmissionResultResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'matchResult': ScoreSubmissionMatchResultToJSON(value['matchResult']),
        'status': value['status'],
        'awaitingConfirmation': value['awaitingConfirmation'],
        'seriesState': value['seriesState'],
    };
}

